import { Flex } from '@chakra-ui/react';
import React from 'react';

import { SectionHeader, SectionText } from '~/core/routes/dev/PageTemplate';

// Exports
type Props<Primary, Secondary, Tertiary> = {
  primaries: readonly Primary[];
  primaryPropName: string;
  secondaries: readonly Secondary[];
  secondaryPropName?: string;
  tertiaries: readonly Tertiary[];
  tertiaryPropName?: string;
  width?: string;
  children: ({
    primary,
    secondary,
    tertiary,
  }: {
    primary: Primary;
    secondary: Secondary;
    tertiary: Tertiary;
  }) => React.ReactElement;
};
export function ComponentGridRenderer<Primary, Secondary, Tertiary>({
  primaries,
  primaryPropName,
  secondaries,
  secondaryPropName,
  tertiaries,
  tertiaryPropName,
  width,
  children,
}: Props<Primary, Secondary, Tertiary>) {
  return (
    <Flex direction="column" gap="1rem">
      {primaries.map((primary) => (
        <React.Fragment key={String(primary)}>
          <SectionHeader>
            {primaryPropName}={`"${primary}"`}
          </SectionHeader>
          <Flex direction="row" gap="2rem">
            {secondaries.map((secondary) => (
              <Flex
                key={String(secondary)}
                direction="column"
                gap="0.5rem"
                width={width ?? undefined}
                minWidth={width ?? undefined}
                flexShrink={0}
              >
                {secondaryPropName && (
                  <SectionText>
                    {secondaryPropName}={`"${secondary}"`}
                  </SectionText>
                )}
                {tertiaries.map((tertiary) => (
                  <Flex
                    key={String(tertiary)}
                    direction="column"
                    gap="0.5rem"
                    flexShrink={0}
                  >
                    {tertiaryPropName && (
                      <SectionText>
                        {tertiaryPropName}={`"${tertiary}"`}
                      </SectionText>
                    )}
                    <Flex
                      gap="0.5rem"
                      justifyContent="space-around"
                      alignItems="center"
                      flexShrink={0}
                    >
                      {children({ primary, secondary, tertiary })}
                    </Flex>
                  </Flex>
                ))}
              </Flex>
            ))}
          </Flex>
        </React.Fragment>
      ))}
    </Flex>
  );
}
